(() => {
  const activate = (root, value) => {
    root.querySelectorAll('[data-mg-best-tab]').forEach((tab) => {
      const active = tab.dataset.mgBestTab === value;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-mg-best-panel]').forEach((panel) => {
      const active = panel.dataset.mgBestPanel === value;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  };

  document.querySelectorAll('[data-mg-best-tabs]').forEach((root) => {
    root.querySelectorAll('[data-mg-best-tab]').forEach((tab) => {
      tab.addEventListener('click', () => activate(root, tab.dataset.mgBestTab));
      tab.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover)').matches) activate(root, tab.dataset.mgBestTab);
      });
      tab.addEventListener('focus', () => activate(root, tab.dataset.mgBestTab));
    });
  });
})();
